<template>
  <div>
    <div class="panel-heading d-flex align-center py-2">
      <h4 class="panel-title">Our Address</h4>

      <div style="text-align: end">
        <v-btn
          v-if="$_has_perm('add_our_address')"
          color="primary"
          style="height: auto;"
          depressed
          @click="addNew()"
        >
          Add New
        </v-btn>
      </div>
    </div>

    <div class="panel-body">
      <v-layout
        row
        wrap
      >
        <v-flex
          sm12
          md4
          lg4
          xl4
          class="px-3"
        >
          <v-text-field
            v-model="queryParams.keyword"
            label="Search..."
            hide-details
            @keypress.enter="getData()"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Title</th>
              <th>Description</th>
              <th>Note</th>
              <th>Warehouse</th>
              <th>TransBy</th>
              <th>Created At</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data, index) in apiData"
              :key="index"
            >
              <td>{{ data.title }}</td>
              <td>
                <div style="white-space: pre-line">{{ data.description }}</div>
              </td>
              <td>{{ data.note }}</td>
              <td>{{ data.country }}</td>
              <td>{{ data.transby }}</td>
              <td>{{ data.created_at | moment('YYYY-MM-DD hh:mm a') }}</td>
              <td>
                <a
                  v-if="$_has_perm('edit_our_address')"
                  tooltip="Edit"
                  @click="editRow(data)"
                >
                  <v-icon color="blue darken-2">edit</v-icon>
                </a>
                <a
                  v-if="$_has_perm('delete_our_address')"
                  tooltip="Delete"
                  @click="deleteRow(data.our_address_id)"
                >
                  <v-icon color="red darken-2">delete</v-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <add-edit
      :addEditModal="addEditModal"
      :warehouses="warehouses"
      :form="form"
      :isUpdate="isUpdate"
      @close="addEditModal = false"
      @resetTable="getData()"
    />
  </div>
</template>

<script>
import Axios from 'axios'
import addEdit from './addEdit.vue'
import swal from 'sweetalert'

export default {
  components: { addEdit },
  data() {
    return {
      apiData: [],
      warehouses: [],
      addEditModal: false,
      isUpdate: false,
      form: {},
      queryParams: {
        keyword: null
      }
    }
  },

  mounted() {
    this.getData()
    this.getWarehouses()
  },

  methods: {
    getWarehouses() {
      let token = localStorage.getItem('access_token')
      Axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        })
    },

    addNew() {
      this.isUpdate = false
      this.form = {
        title: null,
        description: null
      }
      this.addEditModal = true
    },

    editRow(data) {
      this.form = {
        ...data
      }
      this.isUpdate = true
      this.addEditModal = true
    },

    deleteRow(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          Axios.delete(`api/our-address/${id}`, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
            this.getData()
            swal({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          }).catch((error) => {
            swal('Error', error.response.data.message, 'error')
          })
        }
      })
    },

    getData() {
      var token = localStorage.getItem('access_token')

      Axios.get('api/our-address', { params: this.queryParams, headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.apiData = res.data
      })
    }
  }
}
</script>

<style  scoped>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ourAddress/ourAddress.vue